<template>
  <div id='box'>
    <nav class="navbar">
      <div class="logo">
        <img src="/imgs/home/images/header-logo_03.png" alt="">
      </div>
      <!-- 汉堡按钮 -->
      <div class="hamburger" @click="toggleDrawer">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- 抽屉蒙层 -->
      <div class="drawer-mask" v-show="drawerOpen" @click="closeDrawer"></div>
      <!-- 抽屉导航 -->
      <transition name="slide">
        <div class="drawer" v-show="drawerOpen">
          <ul class="drawer-menu">
            <li><router-link to="/" @click.native="closeDrawer">Home</router-link></li>
            <li><router-link to="/goin" @click.native="closeDrawer">About Us</router-link></li>
            <li><router-link to="/product" @click.native="closeDrawer">Products</router-link></li>
            <li><router-link to="/tech" @click.native="closeDrawer">Technology & R&D</router-link></li>
            <li><router-link to="/application" @click.native="closeDrawer">Applications</router-link></li>
            <li><router-link to="/news" @click.native="closeDrawer">News Center</router-link></li>
            <li><router-link to="/contact" @click.native="closeDrawer">Contact Us</router-link></li>
          </ul>

        </div>
      </transition>
      <!-- 桌面端导航 -->
      <ul class="nav-menu">
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/goin">About Us</router-link></li>
        <li><router-link to="/product">Products</router-link></li>
        <li><router-link to="/tech">Technology & R&D</router-link></li>
        <li><router-link to="/application">Applications</router-link></li>
        <li><router-link to="/news">News Center</router-link></li>
        <li><router-link to="/contact">Contact Us</router-link></li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data () {
    return {
      drawerOpen: false,
      lang: 'CN'
    }
  },
  created () {
    const saved = localStorage.getItem('lang')
    if (saved) this.lang = saved
  },
  methods: {
    toggleDrawer () {
      this.drawerOpen = !this.drawerOpen
    },
    closeDrawer () {
      this.drawerOpen = false
    },
    setLang (code) {
      this.lang = code
      localStorage.setItem('lang', code)
      location.reload()
    }
  }
}
</script>

<style scoped>
#box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  padding: 0 10rem;
  position: relative;
  max-width: 100%;
  overflow: hidden;
}
.logo img {
  height: 80px;
}
.nav-menu {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 3rem;
  flex-wrap: nowrap;
  /* overflow: hidden; */
}
.nav-menu li {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.nav-menu a {
  text-decoration: none;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  transition: color .3s;
}
.nav-menu a:hover {
  color: #ff8a00;
}
.lang-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.lang-icons img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

/* 汉堡按钮 */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  cursor: pointer;
  gap: 6px;
}
.hamburger span {
  width: 24px;
  height: 2px;
  background: #333;
  transition: all .3s;
}

/* 抽屉蒙层 */
.drawer-mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.4);
  z-index: 98;
}

/* 抽屉 */
.drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100vh;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0,0,0,.15);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 80px 24px 32px;
}
.drawer-menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
.drawer-menu li {
  margin-bottom: 24px;
}
.drawer-menu a {
  font-size: 18px;
  color: #333;
  text-decoration: none;
  display: block;
  padding: 12px 0;
  transition: color .3s;
}
.drawer-menu a:hover {
  color: #ff8a00;
}
.drawer-lang {
  display: flex;
  gap: 12px;
}
.drawer-lang img {
  width: 24px;
  height: 16px;
  cursor: pointer;
}

/* 抽屉滑入动画 */
.slide-enter-active, .slide-leave-active {
  transition: transform .3s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

/* 大屏幕适配 */
@media (max-width: 1440px) {
  .navbar {
    padding: 0 6rem;
  }
  .nav-menu {
    gap: 2.5rem;
  }
  .nav-menu a {
    font-size: 17px;
  }
}

/* 中等屏幕适配 */
@media (max-width: 1200px) {
  .navbar {
    padding: 0 4rem;
  }
  .nav-menu {
    gap: 2rem;
  }
  .nav-menu a {
    font-size: 16px;
  }
}

/* 小屏幕适配 */
@media (max-width: 992px) {
  .navbar {
    padding: 0 3rem;
    height: 80px;
  }
  .logo img {
    height: 60px;
  }
  .nav-menu {
    gap: 1.5rem;
  }
  .nav-menu a {
    font-size: 15px;
  }
}

/* 平板适配 */
@media (max-width: 768px) {
  .navbar {
    padding: 0 1.5rem;
    height: 70px;
  }
  .logo img {
    height: 50px;
  }
  .nav-menu {
    display: none;
  }
  .hamburger {
    display: flex;
  }
}

/* 手机适配 */
@media (max-width: 480px) {
  .navbar {
    padding: 0 1rem;
    height: 60px;
  }
  .logo img {
    height: 40px;
  }
}
</style>